var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrecisionManufacturing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_40221",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_40221)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.9751 21V18H7.0751L4.5251 9.65002C4.0751 9.40002 3.70426 9.03336 3.4126 8.55002C3.12093 8.06669 2.9751 7.55002 2.9751 7.00002C2.9751 6.16669 3.26676 5.45836 3.8501 4.87502C4.43343 4.29169 5.14176 4.00002 5.9751 4.00002C6.6251 4.00002 7.20426 4.18752 7.7126 4.56252C8.22093 4.93752 8.5751 5.41669 8.7751 6.00002H11.9751V5.00002C11.9751 4.71669 12.0709 4.47919 12.2626 4.28752C12.4543 4.09586 12.6918 4.00002 12.9751 4.00002C13.1251 4.00002 13.2709 4.03336 13.4126 4.10002C13.5543 4.16669 13.6751 4.26669 13.7751 4.40002L15.4751 2.80002C15.6251 2.65002 15.8043 2.55419 16.0126 2.51252C16.2209 2.47086 16.4251 2.50002 16.6251 2.60002L20.5251 4.40002C20.7251 4.50002 20.8626 4.64586 20.9376 4.83752C21.0126 5.02919 21.0084 5.21669 20.9251 5.40002C20.8251 5.60002 20.6793 5.72919 20.4876 5.78752C20.2959 5.84586 20.1084 5.83336 19.9251 5.75002L16.3251 4.10002L13.9751 6.30002V7.70002L16.3251 9.85002L19.9251 8.20002C20.1084 8.11669 20.3001 8.10836 20.5001 8.17502C20.7001 8.24169 20.8418 8.36669 20.9251 8.55002C21.0251 8.75002 21.0334 8.94169 20.9501 9.12502C20.8668 9.30836 20.7251 9.45002 20.5251 9.55002L16.6251 11.4C16.4251 11.5 16.2209 11.5292 16.0126 11.4875C15.8043 11.4459 15.6251 11.35 15.4751 11.2L13.7751 9.60002C13.6751 9.70002 13.5543 9.79169 13.4126 9.87502C13.2709 9.95836 13.1251 10 12.9751 10C12.6918 10 12.4543 9.90419 12.2626 9.71252C12.0709 9.52086 11.9751 9.28336 11.9751 9.00002V8.00002H8.7751C8.7251 8.13336 8.67093 8.25836 8.6126 8.37502C8.55426 8.49169 8.4751 8.61669 8.3751 8.75002L13.3751 18H16.9751V21H3.9751ZM5.9751 8.00002C6.25843 8.00002 6.49593 7.90419 6.6876 7.71252C6.87926 7.52086 6.9751 7.28336 6.9751 7.00002C6.9751 6.71669 6.87926 6.47919 6.6876 6.28752C6.49593 6.09586 6.25843 6.00002 5.9751 6.00002C5.69176 6.00002 5.45426 6.09586 5.2626 6.28752C5.07093 6.47919 4.9751 6.71669 4.9751 7.00002C4.9751 7.28336 5.07093 7.52086 5.2626 7.71252C5.45426 7.90419 5.69176 8.00002 5.9751 8.00002ZM9.1251 18H11.0751L6.7751 10H6.6751L9.1251 18Z",
    fill: "#7F599D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrecisionManufacturing);
export default __webpack_public_path__ + "static/media/precision_manufacturing.d740e6d5b11fd4d03a09523e00773c85.svg";
export { ForwardRef as ReactComponent };